import { useState } from 'react';
import { applyUpdate, useUpdateAvailable } from '../lib/appVersion';

/**
 * 管理アプリの新バージョン通知バナー (任意更新、2026-06-12)。
 *
 * ユーザーアプリの shell/UpdateBanner と同一の UX。検出方式だけ異なり、管理アプリは SW 非搭載の
 * ため build id の version.json ポーリング (lib/appVersion) で新版を検出する。
 *   - **強制リロードしない**。「更新」を押すと window.location.reload() で最新版へ。
 *   - × で当該セッション中は非表示 (次回検出時に再表示)。
 *
 * AdminLayout 直下に 1 つだけ置き、画面下部に fixed で全ページ共通表示する。
 */
export function UpdateBanner() {
  const available = useUpdateAvailable();
  const [dismissed, setDismissed] = useState(false);
  if (!available || dismissed) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] p-2 pointer-events-none">
      <div
        className="mx-auto max-w-md bg-primary-700 text-white px-4 py-3 rounded-lg shadow-lg flex items-center gap-3 pointer-events-auto"
        role="status"
      >
        <div className="flex-1 min-w-0">
          <p className="font-bold text-sm">新しいバージョンがあります</p>
          <p className="text-sm mt-0.5">「更新」を押すと最新版に切り替わります。</p>
        </div>
        <button
          type="button"
          onClick={applyUpdate}
          data-testid="update-banner-apply"
          className="shrink-0 inline-flex items-center rounded bg-white px-3 py-2 text-sm font-bold text-primary-800 hover:bg-slate-100"
        >
          更新
        </button>
        <button
          type="button"
          onClick={() => setDismissed(true)}
          data-testid="update-banner-dismiss"
          aria-label="閉じる"
          className="shrink-0 text-white text-xl px-2 hover:bg-white/10 rounded"
        >
          ×
        </button>
      </div>
    </div>
  );
}
